module.exports = __webpack_public_path__ + "static/media/phone_bezel.58e97145.png";